import(/* webpackMode: "eager" */ "/builds/src/app/(events)/layout.jsx");
